<template>
  <administration-layout>
    <LoadingScreen :isLoading="loading"></LoadingScreen>
    <div class="flex flex-col items-center py-4">
      <div class="w-full xl:px-36 sm:px-8">
        <div class="membership-heading flex flex-row items-center py-4">
          <h1 class="text-lg font-bold inline-flex items-center px-3 py-3">
            <strong>Mi Membresia</strong>
          </h1>
        </div>
        <div class="flex flex-col">
          <content-card slotCustomClass="flex flex-col lg:flex-row" class="membership-overview mb-4">
            <div class="membership-plan-panel w-full lg:w-1/3 lg:mr-2">
              <span class="membership-eyebrow">ESTADO ACTUAL</span>
              <strong class="membership-plan-title">Tu plan:</strong>
              <div class="w-full">
                <el-button size="sm" class="w-full" :class="existsPayment ? 'el-button--primary' : ''"
                  @click="viewPayment">
                  {{
                    existsPayment
                      ? "Administrar mi suscripción " +
                      membershipTypes[$store.state.account.membershipType]
                      : "Contrata tu plan"
                  }}
                </el-button>
                <el-button v-if="isOwner" size="sm" class="w-full mt-2 cancel-membership-button"
                  @click="openCancellationDialog">
                  Cancelar mi suscripción
                </el-button>
              </div>
            </div>
            <div class="membership-date-panel w-full lg:w-1/3 lg:ml-2 lg:mr-2">
              <div class="membership-date-heading">
                <span class="membership-panel-icon"><i class="bx bx-log-in-circle"></i></span>
                <strong>Vence el día:</strong>
              </div>
              <div class="w-full">
                <el-date-picker v-model="$store.state.account.membershipEndDate" type="date" disabled
                  :format="$store.state.business.dateFormat" class="w-full bg-select-button">
                </el-date-picker>
              </div>
            </div>
            <div class="membership-date-panel membership-last-payment w-full lg:w-1/3 lg:ml-2" v-if="existsPayment">
              <strong>Ultimo pago:</strong>
              <div class="w-full flex flex-row">
                <el-date-picker v-model="$store.state.account.membershipLastPay.createdAt" type="date" disabled
                  :format="$store.state.business.dateFormat" class="w-full bg-select-button">
                </el-date-picker>
              </div>
            </div>
          </content-card>
          <div class="membership-sync-banner text-center">
            <span class="text-sm text-gray-600 mb-1">¿Ya realizaste tu pago? </span>
            <span class="text-sm text-purple-600 cursor-pointer flex items-center justify-center gap-2"
              @click="syncStripeAccount">
              <i class="bx bx-info-circle"></i>
              Si no se ha visto reflejado, da click aquí
            </span>
          </div>
          <content-card v-if="existsPayment">
            <div class="flex flex-row items-center">
              <span class="text-lg font-bold">Detalles de tu ultimo Pago</span>
            </div>
            <div class="block w-full overflow-x-auto">
              <table class="items-center w-full border-collapse">
                <thead>
                  <tr class="px-2 border-b-2">
                    <th class="py-3 font-bold text-left border-l-0 border-r-0 whitespace-nowrap">
                      Fecha
                    </th>
                    <th class="py-3 font-bold text-left border-l-0 border-r-0 whitespace-nowrap">
                      Tipo
                    </th>
                    <th class="py-3 font-bold text-left border-l-0 border-r-0 whitespace-nowrap">
                      Monto
                    </th>
                    <th class="py-3 font-bold text-left border-l-0 border-r-0 whitespace-nowrap">
                      Tipo de Moneda
                    </th>
                    <th class="py-3 font-bold text-left border-l-0 border-r-0 whitespace-nowrap">
                      Estatus
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="cursor-pointer hover:bg-gray-100 hover:shadow">
                    <td class="p-2 border-t" style="min-width: 125px">
                      {{ lastPayDate }}
                    </td>
                    <td class="p-2 border-t" style="min-width: 125px">
                      {{ lastPayType }}
                    </td>
                    <td class="p-2 border-t" style="min-width: 125px">
                      {{ moneyFormat(lastPayAmount) }}
                    </td>
                    <td class="p-2 border-t" style="min-width: 125px">
                      {{ lastPayCurrency }}
                    </td>
                    <td class="p-2 border-t" style="min-width: 125px">
                      <div class="text-center rounded-lg text-white" :class="$store.state.account.membershipLastPay.succeeded
                        ? 'success'
                        : 'failed'
                        ">
                        {{ lastPayStatus }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </content-card>

        </div>
      </div>
    </div>

    <el-dialog :visible.sync="cancellationDialogVisible" :show-close="false" width="510px"
      custom-class="cancellation-dialog" @close="resetCancellationDialog">
      <button type="button" class="cancellation-close" @click="closeCancellationDialog">×</button>

      <div v-if="cancellationStep === 1" class="cancellation-content">
        <div class="cancellation-hero">😔</div>
        <h2>¿Por qué quieres cancelar?</h2>
        <p class="cancellation-subtitle">Tu respuesta nos ayuda a mejorar Samii para todos los talleres.</p>

        <div class="cancellation-reasons">
          <div v-for="reason in cancellationReasons" :key="reason.id"
            class="cancellation-reason" :class="{ selected: selectedCancellationReason && selectedCancellationReason.id === reason.id }"
            role="button" tabindex="0" @click="selectCancellationReason(reason)"
            @keydown.enter.prevent="selectCancellationReason(reason)"
            @keydown.space.prevent="selectCancellationReason(reason)">
            <div class="cancellation-reason-main">
              <span class="cancellation-emoji">{{ reason.emoji || '😔' }}</span>
              <div class="cancellation-reason-copy">
                <strong>{{ reason.title }}</strong>
                <span>{{ reason.subtitle }}</span>
              </div>
              <span class="cancellation-radio"><span v-if="selectedCancellationReason && selectedCancellationReason.id === reason.id"></span></span>
            </div>
            <textarea v-if="selectedCancellationReason && selectedCancellationReason.id === reason.id"
              v-model="cancellationDetails" class="cancellation-details" rows="3" @click.stop
              placeholder="Cuéntanos más..."></textarea>
          </div>
        </div>

        <el-button class="cancellation-primary-button" :disabled="!selectedCancellationReason"
          @click="cancellationStep = 2">Continuar →</el-button>
      </div>

      <div v-else class="cancellation-content">
        <div class="cancellation-warning">⚠</div>
        <h2>¿Confirmas que quieres cancelar?</h2>
        <p class="cancellation-subtitle">Tu cuenta se cancelará al final del período de facturación actual.</p>

        <div class="cancellation-losses">
          <span>Vas a perder:</span>
          <p>× &nbsp; Acceso a todas tus órdenes activas e historial</p>
          <p>× &nbsp; Tus clientes y técnicos registrados</p>
          <p>× &nbsp; Reportes y estadísticas de tu taller</p>
          <p>× &nbsp; El precio actual (si cancelas y regresas, los precios pueden cambiar)</p>
        </div>

        <label class="cancellation-label">¿Algo más que quieras decirnos? (opcional)</label>
        <textarea v-model="finalCancellationDetails" class="cancellation-details confirmation-details" rows="3"
          placeholder="Tu opinión importa para los próximos talleres..."></textarea>

        <el-button class="cancellation-primary-button" :loading="cancellationSubmitting" @click="submitCancellation">
          Sí, cancelar mi suscripción
        </el-button>
        <el-button class="cancellation-back-button" :disabled="cancellationSubmitting" @click="closeCancellationDialog">
          No, quiero quedarme
        </el-button>
        <p class="cancellation-footnote">La cancelación es efectiva al final de tu período actual. No hay cobros adicionales.</p>
      </div>
    </el-dialog>
  </administration-layout>
</template>
<style>
.membership-heading { justify-content: space-between; margin-bottom: 10px; }
.membership-heading h1 { color: #172554; font-size: 28px; letter-spacing: -.02em; }
.membership-heading strong { font-weight: 800; }
.membership-heading::after { content: "Cuenta y facturación"; color: #8b2b96; font-size: 11px; font-weight: 700; letter-spacing: .12em; margin-right: 18px; }
.membership-overview { display: block !important; padding: 15px !important; border: 0 !important; border-radius: 10px !important; background: linear-gradient(115deg, #7433ec 0%, #8622df 100%) !important; box-shadow: 0 8px 18px rgba(91, 35, 190, .25) !important; }
.membership-overview > div:last-child { display: grid !important; grid-template-columns: minmax(320px, 1.5fr) minmax(270px, .95fr); gap: 15px; align-items: stretch; }
.membership-plan-panel { width: auto !important; min-height: 160px; padding: 31px 32px 25px; border-radius: 9px; background: transparent; color: #fff; }
.membership-eyebrow { display: block; margin-bottom: 5px; color: rgba(255,255,255,.72); font-size: 10px; font-weight: 700; }
.membership-plan-panel strong.membership-plan-title { display: block; margin-bottom: 16px; color: #fff; font-size: 28px; line-height: 1.1; }
.membership-plan-panel .el-button { width: auto !important; min-width: 128px; height: 33px; padding: 0 16px; border: 0; border-radius: 6px; font-size: 11px; }
.membership-plan-panel .el-button--primary { color: #5726cb !important; background: #fff !important; }
.membership-plan-panel .cancel-membership-button { color: #fff !important; background: rgba(120, 71, 219, .55) !important; border: 1px solid rgba(255,255,255,.16) !important; }
.membership-date-panel { width: auto !important; margin: 0 !important; display: flex; flex-direction: column; align-items: stretch; justify-content: center; gap: 10px; padding: 14px 16px; border-radius: 9px; background: rgba(255,255,255,.13); box-shadow: inset 0 0 0 1px rgba(255,255,255,.16); color: #fff; }
.membership-date-heading { display: flex; align-items: center; gap: 9px; }
.membership-date-panel > div { min-width: 0; }
.membership-date-panel strong { display: block; color: #fff; font-size: 16px; }
.membership-date-panel .membership-panel-icon { display: flex; align-items: center; justify-content: center; width: 34px; height: 34px; border-radius: 50%; background: rgba(255,255,255,.2); color: #fff; font-size: 20px; }
.membership-date-panel .el-date-editor { width: 100% !important; }
.membership-date-panel .el-input__inner { height: 49px; border: 1px solid rgba(255,255,255,.08); border-radius: 6px; background: rgba(137, 77, 224, .65); color: #fff; font-size: 23px; font-weight: 800; }
.membership-date-panel .el-input__prefix { color: rgba(255,255,255,.8); }
.membership-last-payment { display: none; }
.membership-sync-banner { display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; padding: 15px 20px; border: 1px solid #e5d5ec; border-radius: 13px; background: #fbf8fd; color: #6d287d; cursor: pointer; transition: .2s; }
.membership-sync-banner:hover { background: #f4eafa; transform: translateY(-1px); }
.membership-sync-banner small { display: block; color: #718096; margin-top: 2px; }
.membership-sync-icon { font-size: 20px; }
.membership-sync-arrow { font-size: 20px; font-weight: 700; }
@media (max-width: 700px) { .membership-overview > div:last-child { grid-template-columns: 1fr; } .membership-plan-panel { min-height: auto; padding: 24px 20px; } .membership-heading::after { display: none; } }
.success {
  background-color: forestgreen;
}

.failed {
  background-color: firebrick;
}

.cancel-membership-button {
  color: #8b2b96 !important;
  border-color: #c9a1d0 !important;
}

.cancellation-dialog { border-radius: 16px; }
.cancellation-dialog .el-dialog__header,
.cancellation-dialog .el-dialog__footer { display: none; }
.cancellation-dialog .el-dialog__body { padding: 24px 20px 22px; }
.cancellation-content { position: relative; text-align: center; color: #172033; }
.cancellation-close { position: absolute; top: 8px; right: 8px; border: 0; background: transparent; color: #718096; font-size: 26px; cursor: pointer; line-height: 1; padding: 6px 8px; z-index: 1; }
.cancellation-hero { font-size: 35px; margin-bottom: 6px; }
.cancellation-warning { display: inline-flex; align-items: center; justify-content: center; width: 48px; height: 48px; border-radius: 50%; background: #fff0f0; color: #ef4444; font-size: 28px; margin-bottom: 10px; }
.cancellation-content h2 { margin: 0 0 8px; font-size: 21px; font-weight: 700; }
.cancellation-subtitle { margin: 0 0 24px; color: #718096; font-size: 14px; }
.cancellation-reasons { display: flex; flex-direction: column; gap: 8px; text-align: left; }
.cancellation-reason { border: 1px solid #dce4ef; border-radius: 12px; padding: 12px 14px; cursor: pointer; transition: border-color .15s, box-shadow .15s; }
.cancellation-reason, .cancellation-reason * { cursor: pointer; }
.cancellation-reason textarea { cursor: text; }
.cancellation-reason.selected { border: 2px solid #8b2b96; padding: 11px 13px; background: #fcf8fd; box-shadow: 0 3px 10px rgba(139, 43, 150, .12); }
.cancellation-reason-main { display: flex; align-items: center; gap: 12px; }
.cancellation-emoji { width: 24px; text-align: center; font-size: 20px; }
.cancellation-reason-copy { display: flex; flex: 1; min-width: 0; flex-direction: column; gap: 3px; }
.cancellation-reason-copy strong { font-size: 14px; font-weight: 700; }
.cancellation-reason-copy span { color: #718096; font-size: 12px; }
.cancellation-radio { width: 16px; height: 16px; border: 2px solid #cbd5e1; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.cancellation-reason.selected .cancellation-radio { border-color: #8b2b96; }
.cancellation-radio span { width: 8px; height: 8px; border-radius: 50%; background: #8b2b96; }
.cancellation-details { display: block; width: 100%; box-sizing: border-box; margin-top: 10px; border: 1px solid #dce4ef; border-radius: 8px; padding: 10px 11px; resize: vertical; color: #172033; font-family: inherit; font-size: 13px; outline: none; }
.cancellation-details:focus { border-color: #8b2b96; }
.cancellation-primary-button { width: 100%; margin-top: 20px; border: 0 !important; border-radius: 11px !important; background: #8b2b96 !important; color: white !important; font-weight: 700 !important; height: 44px; }
.cancellation-primary-button.is-disabled { background: #c9a8cf !important; color: white !important; }
.cancellation-losses { text-align: left; background: #fff4f4; border-radius: 12px; padding: 14px 16px; margin: 20px 0 16px; color: #475569; font-size: 12px; }
.cancellation-losses span { display: block; margin-bottom: 6px; color: #334155; font-weight: 700; }
.cancellation-losses p { margin: 2px 0; line-height: 1.35; }
.cancellation-losses p::first-letter { color: #ef4444; }
.cancellation-label { display: block; text-align: left; color: #334155; font-size: 12px; margin-bottom: 6px; }
.confirmation-details { margin-top: 0; text-align: left; }
.cancellation-back-button { width: 100%; margin: 8px 0 0 !important; border: 1px solid #ef4444 !important; border-radius: 11px !important; color: #ef4444 !important; height: 44px; font-weight: 700 !important; }
.cancellation-footnote { color: #718096; font-size: 11px; margin: 12px 0 0; }
</style>
<script>
import _ from "lodash";
import error from "@/mixins/error";
import numbers from "@/utils/numbers";
import { MembershipEnum, AccountTypeEnum } from "@/constants";
import PaymentService from "@/services/PaymentService";
import PaymentDialogService from "@/components/dialogs/Payment/service";

export default {
  name: "Membership",
  mixins: [error],
  components: {
    AdministrationLayout: () =>
      import("@/components/organisms/TheAdministrationApp"),
    ContentCard: () => import("@/components/molecules/ContentCard"),
    LoadingScreen: () => import("@/components/layouts/LoadingScreen"),
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      visibleLastPaymentDetails: false,
      cancellationDialogVisible: false,
      cancellationStep: 1,
      cancellationReasons: [],
      selectedCancellationReason: null,
      cancellationDetails: "",
      finalCancellationDetails: "",
      cancellationSubmitting: false,
      membershipTypes: {
        [MembershipEnum.Basic]: "Básico",
        [MembershipEnum.Professional]: "Profesional",
        [MembershipEnum.Premium]: "Premium",
      },
    };
  },
  watch: {
    errorMessage: {
      deep: true,
      handler: _.debounce(async function () {
        if (this.errorMessage) {
          await this.$toastr.e(this.errorMessage);
          this.errorMessage = undefined;
        }
      }, 300),
    },
  },
  computed: {
    existsPayment() {
      return this.$store.state.account.membershipLastPay.createdAt;
    },
    lastPayDate() {
      const format =
        this.$store.state.business.dateFormat?.toUpperCase() ?? "MM/DD/YYYY";
      return this.$moment(
        new Date(this.$store.state.account.membershipLastPay.createdAt)
      ).format(format);
    },
    lastPayType() {
      return (
        {
          payment_intent: "Pago",
        }[this.$store.state.account.membershipLastPay.object] || "Pago"
      );
    },
    lastPayAmount() {
      return this.$store.state.account.membershipLastPay.amount / 100;
    },
    lastPayCurrency() {
      return this.$store.state.account.membershipLastPay.currency.toUpperCase();
    },
    lastPayStatus() {
      return this.$store.state.account.membershipLastPay.succeeded
        ? "Exitoso"
        : "Fallido";
    },
    isOwner() {
      return this.$store.state.account.accountType === AccountTypeEnum.Owner;
    },
  },
  methods: {
    async openCancellationDialog() {
      try {
        this.loading = true;
        this.resetCancellationDialog();
        this.cancellationDialogVisible = true;
        this.cancellationReasons = await PaymentService.cancellationReasons();
      } catch (e) {
        this.cancellationDialogVisible = false;
        this.errorMessage = this.getErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
    closeCancellationDialog() {
      this.cancellationDialogVisible = false;
      this.resetCancellationDialog();
    },
    resetCancellationDialog() {
      this.cancellationStep = 1;
      this.selectedCancellationReason = null;
      this.cancellationDetails = "";
      this.finalCancellationDetails = "";
    },
    selectCancellationReason(reason) {
      this.selectedCancellationReason = reason;
    },
    async submitCancellation() {
      if (!this.selectedCancellationReason || this.cancellationSubmitting) return;
      try {
        this.cancellationSubmitting = true;
        await PaymentService.cancelAccount({
          cancellationReasonId: this.selectedCancellationReason.id,
          details: [this.cancellationDetails.trim(), this.finalCancellationDetails.trim()].filter(Boolean).join("\n\n") || "Canceló sin responder.",
          additionalOpinion: this.finalCancellationDetails.trim(),
        });
        this.closeCancellationDialog();
        await this.$swal.fire({
          title: "Solicitud registrada",
          text: "Tu suscripción se cancelará al final del período de facturación actual.",
          icon: "success",
          confirmButtonText: "Aceptar",
        });
      } catch (e) {
        this.errorMessage = this.getErrorMessage(e);
      } finally {
        this.cancellationSubmitting = false;
      }
    },
    async syncStripeAccount() {
      try {
        this.loading = true;
        await PaymentService.syncStripeAccount(this.$store.state.account.id);
        this.$swal.fire({
          title: "Cuenta sincronizada.",
          icon: "success",
          text: "El proceso de sincronización se ha completado exitosamente. Si realizaste un pago recientemente, debería reflejarse en tu cuenta ahora.",
          timer: 10000,
          timerProgressBar: true,
          confirmButtonText: "Aceptar"
        }).then(() => {
          window.location.reload();
        });
      } catch (error) {
        this.handleError(error);
        this.$swal.fire({
          title: "Error al sincronizar.",
          icon: "error",
          text: "Hubo un error al sincronizar la información de tu cuenta. Por favor, intenta nuevamente más tarde.",
        });
      }
      finally {
        this.loading = false;
      }

    },
    viewPayment() {
      if (this.$store.state.account.accountType !== AccountTypeEnum.Owner) {
        this.$swal.fire({
          title: "Acceso Denegado.",
          icon: "error",
          text: "Los pagos se deben realizar desde la cuenta madre (Dueño) con la que se inicio en samii.",
        });
        return;
      }
      if (this.existsPayment) {
        const url_with_email = this.$store.state.account.stripeCustomerUrl;
        window.open(url_with_email, "_blank");
        return;
      }
      PaymentDialogService.show();
    },
    moneyFormat(value) {
      const { currencySymbol } = this.$store.state.account;
      return numbers.moneyFormat(value, currencySymbol);
    },
    confirmUnsubscribe() {
      this.$confirm(`¿Está seguro que deseas cancelar tu subscripcion?`, {
        type: "warning",
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then(async () => {
        await this.unsubscribe();
      });
    },
    async unsubscribe() {
      try {
        await PaymentService.unsubscribe();
        this.$toastr.s("Has cancelado tu subscripcion");
      } catch (e) {
        this.errorMessage = this.getErrorMessage(e);
      }
    },
  },
};
</script>
